import * as React from "react";
import Table, { ColumnProps } from "antd/lib/table";
import { GetBLbyConsigneeResponseDto, BolListData } from "Core/Api/APMProxy/Api";
import { NavLink } from "react-router-dom";
import SimpleTable from "components/Forms/DataGrid/SimpleTable";
import { CustomerBolHandler } from "../CustomerBolHandler";
import NotificationUtility from "Core/NotificationUtility";

export interface Props {
    children?: React.ReactNode
    customerCode?: string,
}

export interface State {
    customerBols: BolListData[]
}

export default class CustomerBolTable extends React.Component<Props, State> {
    customerBolHandler: CustomerBolHandler;

    columns: Array<ColumnProps<BolListData>> = [
        {
            title: 'BL #',
            key: 'bolNumber',
            render: (text: any, record: BolListData, index: number) => record.bolNumber || record["bolReferenceNumber"]
        },
        {
            title: 'Description',
            dataIndex: 'description',
            width: "40%"
        },
        {
            title: 'Click N Collect',
            dataIndex: 'clickAndGo',
            render: (text: boolean) => <>{text == true ? "Yes" : "No"} </>
        },
        {
            title: '',
            render: (text: any, record: BolListData, index: number) => <><NavLink to={{ pathname: '/customer-bol/detail', search: '?bolNo=' + record.bolNumber || record["bolReferenceNumber"] }}>Get Charges</NavLink></>
        }

    ]

    constructor(props: Props) {
        super(props)

        this.customerBolHandler = new CustomerBolHandler(props);

        this.state = {
            customerBols: []
        }
    }

    componentDidMount() {
        console.log("this.props.customerCode", this.props.customerCode);
        this.getCustomerBols();
    }

    getCustomerBols = () => {
        if (this.props.customerCode) {
            this.customerBolHandler.GetCustomerBol(this.props.customerCode)
                .then((customerBol: GetBLbyConsigneeResponseDto) => {
                    if (customerBol.data) {
                        this.setState({ customerBols: customerBol.data })
                    }

                });
        }
    }

    render() {
        return (
            <Table
                key="customerBolTable"
                dataSource={this.state.customerBols}
                columns={this.columns} />
        )
    }
}
